module.exports = __webpack_public_path__ + "static/media/11NEPAD6.557b5175.jpg";